import Vue from "vue";
import Vuex from "vuex";


Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        chinese: true,
        webconfig: {}
    },
    mutations: {
        changeLang() {
            this.state.chinese = !this.state.chinese
        }
    }
})
export default store


// WEBPACK FOOTER //
// ./src/store.js